import { call, put, takeEvery, all } from 'redux-saga/effects';
import fileDownload from 'js-file-download';
import AssessmentApi from '../../api/AssessmentApi';
import * as Actions from '../actions/assessmentsActions';
import * as Types from '../actions/assessmentsActionTypes';
import history from '../../utils/history';

function* postAssessment(action) {
  const { id, onFail } = action;
  const assessment = {
    section: id,
    answers: {},
  };
  try {
    const response = yield call(AssessmentApi.postAssessment, assessment);
    console.info(response);
    yield put(Actions.getAssessmentSuccess(response)); // update state.assessments.list
    yield put(Actions.updateCurrentAssessment(response)); // update current assessment
    yield call(history.push, `/assessments/${response.id}/preface`); // begin assessment
  } catch (error) {
    console.info(error);
    yield put(Actions.postAssessmentFailure(error));
    yield call(onFail, error);
  }
}

function* putAssessment(action) {
  const { assessment, complete, onFail, onSuccess } = action;
  try {
    const response = yield call(AssessmentApi.putAssessment, assessment, complete);
    console.info(response);
    yield put(Actions.getAssessmentSuccess(response)); // update state.assessments.list
    yield put(Actions.updateCurrentAssessment(response)); // update current assessment
    yield call(onSuccess);
  } catch (error) {
    console.info(error);
    yield put(Actions.putAssessmentFailure(error));
    yield call(onFail, error);
  }
}

function* splitPutAssessment(action) {
  const { assessment, onSuccess, onFail } = action;
  try {
    const response = yield call(AssessmentApi.splitPutAssessment, assessment);
    console.info(response);
    yield put(Actions.getAssessmentSuccess(response)); // update state.assessments.list
    yield put(Actions.updateCurrentAssessment(response)); // update current assessment
    yield call(onSuccess, response);
  } catch (error) {
    console.info(error);
    yield put(Actions.putAssessmentFailure(error));
    yield call(onFail, error);
  }
}

function* forcePutAssessment(action) {
  const { assessment, onSuccess, onFail } = action;
  try {
    const response = yield call(AssessmentApi.forcePutAssessment, assessment);
    console.info(response);
    yield put(Actions.getAssessmentSuccess(response)); // update state.assessments.list
    yield put(Actions.updateCurrentAssessment(response)); // update current assessment
    yield call(onSuccess, response);
  } catch (error) {
    console.info(error);
    yield put(Actions.putAssessmentFailure(error));
    yield call(onFail, error);
  }
}

function* uploadAssessment(action) {
  const { assessment, onProgress } = action;
  try {
    const response = yield call(AssessmentApi.uploadAssessment, assessment, onProgress);
    console.info(response);
    yield put(Actions.uploadAssessmentSuccess(response)); // save it to state.assessments.list
  } catch (error) {
    console.info(error);
    yield put(Actions.uploadAssessmentFailure(error));
  }
}

function* downloadAssessment(action) {
  const { assessmentId, onSuccess } = action;
  try {
    const response = yield call(AssessmentApi.downloadAssessment, assessmentId);
    yield put(Actions.downloadAssessmentSuccess());
    yield call(onSuccess, response);
  } catch (error) {
    console.info(error);
    yield put(Actions.downloadAssessmentFailure(error));
  }
}

function* downloadComparison(action) {
  const { assessmentIds, onSuccess } = action;
  try {
    const response = yield call(AssessmentApi.downloadComparison, assessmentIds);
    fileDownload(new Blob([response], { type: 'application/pdf' }), 'comparison.pdf', 'application/pdf');
    yield put(Actions.downloadComparisonSuccess());
    yield call(onSuccess);
  } catch (error) {
    console.info(error);
    yield put(Actions.downloadComparisonFailure(error));
  }
}

function* getAssessments() {
  try {
    const response = yield call(AssessmentApi.getAssessments);
    console.info(response);
    yield put(Actions.getAssessmentsSuccess(response));
  } catch (error) {
    console.info(error);
    yield put(Actions.getAssessmentsFailure(error));
  }
}

function* getAssessment(action) {
  try {
    const response = yield call(AssessmentApi.getAssessment, action.id);
    console.info(response);
    yield put(Actions.getAssessmentSuccess(response));
    if (action.updateCurrentAssessment) {
      yield put(Actions.updateCurrentAssessment(response));
    }
  } catch (error) {
    console.info(error);
    yield put(Actions.getAssessmentFailure(error));
    action.onFail(error);
  }
}

export default function* AssessmentFlow() {
  yield all([
    takeEvery(Types.PUT_ASSESSMENT, putAssessment),
    takeEvery(Types.SPLIT_PUT_ASSESSMENT, splitPutAssessment),
    takeEvery(Types.FORCE_PUT_ASSESSMENT, forcePutAssessment),
    takeEvery(Types.UPLOAD_ASSESSMENT, uploadAssessment),
    takeEvery(Types.DOWNLOAD_ASSESSMENT, downloadAssessment),
    takeEvery(Types.DOWNLOAD_COMPARISON, downloadComparison),
    takeEvery(Types.GET_ASSESSMENTS, getAssessments),
    takeEvery(Types.GET_ASSESSMENT, getAssessment),
    takeEvery(Types.SELECT_SECTION, postAssessment),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/assessmentFlow.js